export default "<ngx-loading-bar [includeSpinner]=\"false\"></ngx-loading-bar>\r\n<router-outlet></router-outlet>\r\n"